import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import { fetchShortcuts } from '../../../services/sidebar/index.tsx';
import type { ProjectShortcut } from '../../../types.tsx';

const getIdentifier = (match: Match, query: Query): string => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};

export const staticSidebarShortcutsResource = createResource<ProjectShortcut[] | null>({
	type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
	getKey: ({ match, query }) => getIdentifier(match, query) ?? 'none',
	getData: async ({ match, query }) => {
		const projectKeyOrId = getIdentifier(match, query);
		if (projectKeyOrId == null) {
			return null;
		}

		const shortcuts = await fetchShortcuts(projectKeyOrId);
		return shortcuts;
	},
	maxAge: 5 * 60 * 1000,
	isCritical: true,
});
